/**
 * TuVi Report Constants
 * 
 * Hardcode dimensions và metrics thay vì gọi API common/dimensions và common/metrics
 * Vì TuViReport chỉ có 3 dimensions và 2 metrics cố định
 */

// Dimensions cho TuVi Report (id khớp DIMENSION_ID của backend TuviReport)
export const TUVI_DIMENSIONS = [
      { id: 1, name: 'Ngày' },
      { id: 2, name: 'Tính năng' },
      { id: 3, name: 'Đối tác' }
];

// Metrics cho TuVi Report  
export const TUVI_METRICS = [
      { id: 1, name: 'Lượt sử dụng' },
      { id: 2, name: 'Người sử dụng' }
];

// Permission path
export const PATH = 'sudungdichvutuvi';

// Page title
export const PAGE_TITLE = 'Tử vi';

// Export filename
export const EXPORT_FILENAME = 'TUVIREPORT';
